<script>
	import model from "../../stores/modelStore";
	import { projectSettings, acceptedFileUploadList } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import { registerPageComplete } from "../../tealium";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let pageName = null;
	export let disabled = null;
	export let pageTitle = null;
	export let lastVisitedPage = null;

	let buttons = null;

	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.registrationToken,
		acceptedFiles: acceptedFileUploadList,
		fileUploadToken: $model.registrationToken
	};

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);
		buttons.next();
	};

	$model.documentList = $model.documentList || [];
</script>

<PageSection>
	<Form {disabled} id="form-document-upload" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please upload your documents</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			{#if !disabled}
				<p>
					Please upload any supporting documents you may have. For example, if you have copies of your medical
					records (specifically, any records in respect of your diagnosis and/or treatment of your ovarian or
					other reproductive cancer), please upload and they will be saved as part of your registration.
				</p>

				<FormRow>
					<FormColumn>
						<DropZone
							{options}
							{id}
							message="Drop files here or click to upload for this registration"
							bind:documentList={$model.documentList}
						></DropZone>
					</FormColumn>
				</FormRow>
			{:else}
				<div class="form-group">
					<h2>Uploaded Documents</h2>

					{#if $model.documentList && $model.documentList.length > 0}
						<table class="table table-sm">
							<tr>
								<th>Document Name</th>
							</tr>
							{#each $model.documentList as file}
								<tr>
									<td>{file.fileName}</td>
								</tr>
							{/each}
						</table>
					{:else}
						<p>No documents uploaded</p>
					{/if}
				</div>
			{/if}
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<SaveAndClose>Save and Close</SaveAndClose>
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>
